export const development: any = [
    { name: "Developing the screening tool", route: "developing-the-tool" },
    { name: "Considerations & limitations", route: "considerations-limitations" },
    { name: "Collaborators & publications", route: "collaborators-publications" }
];

export const screeningTool: any = [
    { name: "Introduction", route: "introduction" },
    { name: "Start screening", route: "start-screening" },
    { name: "Feedback", route: "feedback" }
];
